import * as React from "react";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {BackButton} from "../../../../../components/navigation/BackButton";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {getSessionStorage} from "../../../../../CommonFunctions";
import {FalconNavigatorHeader, resourcesHelper, CLAIM_TYPE_BREAKDOWN, CLAIM_TYPE_MOTOR} from "@falcon/services";
import {Button} from "reactstrap";
import {AllianzOnlineBadge} from "../../../../../components/AllianzOnlineBadge";
import {IWithRouterProps, withRouter} from "@athena-portal/components";

interface IWindscreenOrBreakdownClaimPageParams {
    policyNumber: string;
    [key: string]: string | undefined
}

export class WindscreenOrBreakdownClaimPagePlain extends React.Component<IWithRouterProps<IWindscreenOrBreakdownClaimPageParams>> {

    constructor(props: IWithRouterProps<IWindscreenOrBreakdownClaimPageParams>) {
        super(props);
    }

    public render() {
        const claim: string = getSessionStorage("claim");
        const isBritanniaBrand = ["bn", "britannia"].includes((resourcesHelper.THEME || "").toLowerCase());
        let claimTitle;

        if(claim === CLAIM_TYPE_MOTOR){
            claimTitle = "Windscreen Claim Reporting";
        }else if(claim === CLAIM_TYPE_BREAKDOWN){
            claimTitle = "Breakdown claim Reporting";
        }else{
            claimTitle = "All other claims";
        }

        return (
            <React.Fragment>
                <FalconHeader/>
                    <div className="page-contents dashboard-page">
                        <AllianzOnlineBadge/>
                        <FalconNavigatorHeader
                            back={`/dashboard/pickAnnualMotorClaimKind/${this.props.params.policyNumber}`}
                            title={
                                isBritanniaBrand &&
                                typeof claimTitle === "string" &&
                                (
                                    claimTitle.toLowerCase().includes("windscreen claim reporting") ||
                                    claimTitle.toLowerCase().includes("breakdown claim reporting")
                                )
                                    ? {
                                        html: (
                                            <div className="text-group title plugin no-indent-desktop">
                                                <h1 className="m-0">
                                                    <span>{claimTitle.replace(/claim reporting/i, "")}</span>
                                                    <span className="claim-highlight">Claim Reporting</span>
                                                </h1>
                                            </div>
                                        )
                                    }
                                    : claimTitle
                            }
                        />
                        <div className="panel claim-page reset-margins">
                            <div className="dl-widget-video-panel">
                                <img className="claims-icon" src={`/${resourcesHelper.THEME}/img/make-a-claim.png`} alt="Make a claim icon"/>
                            </div>
                            <p className="mt-4 mb-4 font-weight-bold text-center claim-text">{claim === CLAIM_TYPE_MOTOR ?
                                "To report a windscreen or glass damage get in touch with our recommended windscreen provider. You can arrange an appointment on-line by using the button below. It's simple and quick!" :
                                "For any claims on your car(s) call our 24 hour helpline"}</p>
                            {claim === CLAIM_TYPE_MOTOR && (
                                <div className="windscreen-options">
                                    <div className="dl-widget-video-panel windscreen-icon grid-row-1">
                                        <img className="windscreen-icon" src="/img/national-windscreens-logo.png" alt="National Windscreens icon"/>
                                    </div>
                                    <Button
                                        className="my-2 w-100 grid-col-1"
                                        color="btn btn-primary btn-next-no-arrow"
                                        href="https://www.nationalwindscreens.co.uk/allianzcar"
                                    >
                                        Book National Windscreens
                                    </Button>
                                    <p className="mt-4 mb-4 font-weight-bold text-center grid-col-1-2">
                                        Or call us on our 24 hour helpline and select option #1
                                    </p>
                                </div>
                            )}
                            <div className="text-center mb-4">
                                <a
                                    href={claim === CLAIM_TYPE_BREAKDOWN ? resourcesHelper.MOTOR_CLAIMS_BREAKDOWN_PHONE_TEL : resourcesHelper.MOTOR_CLAIMS_WINDSCREEN_PHONE_TEL}
                                    className="mb-4 no-underline font-weight-semi-bold icon-phone-before margin-top-10"
                                    id="claimsPagePhoneLink"
                                    aria-label={claim === CLAIM_TYPE_BREAKDOWN ? "Phone number " + resourcesHelper.MOTOR_CLAIMS_BREAKDOWN_PHONE_DISPLAY : "Phone number " + resourcesHelper.MOTOR_CLAIMS_WINDSCREEN_PHONE_DISPLAY}
                                >
                                    { claim === CLAIM_TYPE_BREAKDOWN ? resourcesHelper.MOTOR_CLAIMS_BREAKDOWN_PHONE_DISPLAY : resourcesHelper.MOTOR_CLAIMS_WINDSCREEN_PHONE_DISPLAY }
                                </a>
                                {(claim === CLAIM_TYPE_MOTOR || claim === CLAIM_TYPE_BREAKDOWN) && (
                                    <>
                                        <p className="font-weight-bold mb-1 mt-3 margin-top-10">From abroad</p>
                                        <a
                                            href={
                                                claim === CLAIM_TYPE_BREAKDOWN
                                                    ? resourcesHelper.MOTOR_CLAIMS_BREAKDOWN_PHONE_ABROAD_TEL
                                                    : resourcesHelper.MOTOR_CLAIMS_WINDSCREEN_PHONE_ABROAD_TEL
                                            }
                                            className="mb-4 no-underline font-weight-semi-bold icon-phone-before margin-top-10"
                                            id="claimsPagePhoneLinkAbroad"
                                            aria-label={
                                                claim === CLAIM_TYPE_BREAKDOWN
                                                    ? "Phone number " + resourcesHelper.MOTOR_CLAIMS_BREAKDOWN_PHONE_ABROAD_DISPLAY
                                                    : "Phone number " + resourcesHelper.MOTOR_CLAIMS_WINDSCREEN_PHONE_ABROAD_DISPLAY
                                            }
                                        >
                                            {
                                                claim === CLAIM_TYPE_BREAKDOWN
                                                    ? resourcesHelper.MOTOR_CLAIMS_BREAKDOWN_PHONE_ABROAD_DISPLAY
                                                    : resourcesHelper.MOTOR_CLAIMS_WINDSCREEN_PHONE_ABROAD_DISPLAY
                                            }
                                        </a>
                                    </>
                                )}
                            </div>
                            <p className="text-center margin-top-10">
                                Lines open {isBritanniaBrand ? <strong>24 hours, 7 days a week.</strong> : "24 hours, 7 days a week."}{' '}
                                Calls will be recorded. For Text Phone, first dial 18001
                            </p>

                        </div>
                        <BackButton isTop={false} link={`/dashboard/pickAnnualMotorClaimKind/${this.props.params.policyNumber}`}/>
                    </div>
                <FalconFooter/>
            </React.Fragment>
        );
    }
}

export const WindscreenOrBreakdownClaimPage = withRouter<{}, IWindscreenOrBreakdownClaimPageParams>(WindscreenOrBreakdownClaimPagePlain)
